import React from "react";
import keyBy from "lodash/keyBy";
import orderBy from "lodash/orderBy";
import defaults from "lodash/defaults";
import { filterByPath } from "../../../utils/array-helpers";
import View from "./coaching-dashboard-view";
import { DATE_FORMATS } from "../../../constants";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const { DATE_YEAR_FORMAT } = DATE_FORMATS;

const CoachingDashboardController = async ({ res, req, locals, load }) => {
  const momentTZ = locals.momentTZ;
  const { query = {} } = req;
  defaults(query, {
    email: "",
    modal: {},
    filters: {},
    sort: JSON.stringify([[]]),
    month: momentTZ().format(DATE_YEAR_FORMAT),
    filterGroup: "all",
  });
  const {
    filters,
    sort,
    month,
    filterGroup,
    organizationCoach = undefined,
    metric,
  } = query;

  const { organizationId = null } = locals.activeUser;

  if (organizationId) {
    await load("usersOrganization");
  }

  const currentDate = momentTZ();
  locals.today = currentDate.date();
  locals.activeMonth = momentTZ(month, DATE_YEAR_FORMAT);
  const currentM = currentDate.month();
  const currentY = currentDate.year();
  const activeM = locals.activeMonth.month();
  const activeY = locals.activeMonth.year();
  locals.isCurrentMonth = currentM === activeM && activeY === currentY;
  locals.isPreviousMonth =
    (currentY === activeY && currentM > activeM) || currentY > activeY;
  locals.totalDays = locals.activeMonth.daysInMonth();

  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin" ||
      locals.organizationRoleName === "Nutritionist");

  const organizationCoachId =
    filterGroup !== "all"
      ? locals.usersOrganization?.organizationActiveUsers?.map(
          ({ _id }) => _id
        ) || organizationCoach
      : organizationCoach;

  const loadPromises = [];
  if (organizationCoachId) {
    loadPromises.push(
      load("coachOrganizationInformation", { user: organizationCoach })
    );
  }

  loadPromises.push(
    load(
      "coachingDashboardForMonth",
      locals.activeMonth.month() + 1,
      locals.activeMonth.year(),
      organizationCoachId,
      metric
    )
  );

  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    loadPromises.push(load("allAthletesFromOrganization"));
  }

  await Promise.all(loadPromises);

  let allAthletes = locals.coachingDashboardForMonth.result
    ? [...locals.coachingDashboardForMonth.result]
    : [];

  if (filterGroup && filterGroup !== "all" && filterGroup !== "organization") {
    const athletesUsers = locals.allAthletesFromOrganization
      ? keyBy([...locals.allAthletesFromOrganization], "athleteId")
      : locals.coachOrganizationInformation
      ? keyBy([...locals.coachOrganizationInformation.athletes], "_id")
      : keyBy([...locals.activeUser.athletes], "_id");

    allAthletes = allAthletes.filter((athlete) => {
      const fullAthlete = athletesUsers[athlete._id];

      return (
        fullAthlete &&
        ((fullAthlete.groups && fullAthlete.groups.includes(filterGroup)) ||
          (fullAthlete.athleteGroups &&
            fullAthlete.athleteGroups.includes(filterGroup)))
      );
    });
  }

  locals.athletes = orderBy(
    filterByPath(allAthletes, filters),
    ...JSON.parse(sort)
  );

  //filter by name and email using regexp
  if (query.name) {
    locals.athletes = locals.athletes.filter((athlete) => {
      return (
        new RegExp("^.*" + query.name + ".*$", "gi").test(athlete.name) ||
        new RegExp("^.*" + query.name + ".*$", "gi").test(athlete.email)
      );
    });
  }

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <View />;
};

export default CoachingDashboardController;
